import { Box, Typography } from '@mui/material';
import SignatureBox, { SignatureBoxRef } from 'components/featured/documents/SignatureBox';
import { DocsHRPostPayload, submitHRForm, uploadHRFile } from 'core/API/documents';
import { useProviderFunctions } from 'core/components/Toast/context/ToastContext';
import { FormGroupSection, SignAndSubmit,  NextAndCancel} from 'module/documents/components/components';
import DynamicFormComponent from 'module/documents/components/formTabs/DynamicFormComponent';
import { EmployerFields } from 'module/documents/components/formTabs/EmployerFields';
import { useDocumentContext } from 'module/documents/context';
import { EmployerFieldsForm } from 'module/documents/data';
import { useState, FC, useMemo } from 'react';
import { useQueryClient } from 'react-query';
import { validateForm } from 'module/documents/utils';
import { useRef } from 'react';

const allEmployerFields = EmployerFieldsForm.fields
	.map((field) => field.value)
	.filter((value) => value !== 'first_date_employment');
interface HumanResourceFormProps {
	setEmployerSignatureFile: React.Dispatch<React.SetStateAction<File | string | null>>;
}

export const HumanResourceTab: FC<HumanResourceFormProps> = ({
	setEmployerSignatureFile
}) => {
	const [signatureSubmitted, setSignatureSubmitted] = useState(false);
	const { formik, isEmployer, submittedForms, setSubmittedForms, setActiveTabIndex, selectedEmployee } = useDocumentContext();
	const { showToast } = useProviderFunctions();
	const queryClient = useQueryClient();
	const signatureRef = useRef<SignatureBoxRef>(null);
	const isGlobalReadOnly = submittedForms.human_resource_data_submitted;
	const handleFormSubmit = async () => {
		let uploadedSignatureId = formik.values?.employer_signature_id || null;

		if ((uploadedSignatureId == null || uploadedSignatureId === true) && signatureRef.current) {
			uploadedSignatureId = await signatureRef.current.submitSignature();
		}
		const payload: DocsHRPostPayload = {
			employer_title: formik.values.employer_title,
			employer_name: formik.values.employer_name,
			employer_business_name: formik.values.employer_business_name,
			phone: "",
			address: formik.values.employer_business_address,
			city: formik.values.employer_city,
			state: formik.values.employer_state,
			zip_code: formik.values.employer_zip_code,
			country: formik.values.country,
			employer_ein: formik.values.employer_ein,
			signature_approved: true,
			// signature_file: {
			// 	id: Number(uploadedSignatureId),
			// },
		};
		try {
			await submitHRForm(payload);
			showToast('success', 'Form submitted successfully!');
			// Commented out - employee-form API calls not needed
			// queryClient.invalidateQueries(['employee-form/hr']);
			setSubmittedForms(prev => ({
				...prev,
				human_resource_data_submitted: true,
			}));
			setActiveTabIndex(2);
		} catch (error) {
			console.error('Error submitting form:', error);
			showToast('error', 'Error submitting form!');
		}
	};

	const handleSignatureSubmit = async (file: File) => {
		try {
			const response = await uploadHRFile(file);
			setEmployerSignatureFile(file);
			console.log('Signature uploaded successfully:', response);
			formik.setFieldValue('employer_signature', true);
			formik.setFieldValue('signature_file_id', response.id);
			formik.setFieldValue('employer_signature_path', response.path);
			setSignatureSubmitted(true);
			return response.id?.toString() || null;
		} catch (error) {
			console.error('Error uploading signature:', error);
			formik.setFieldValue('employer_signature_path', '');
			setEmployerSignatureFile(file);
			formik.setFieldValue('employer_signature', false);
			return null;
		}
	};

	return (
		<Box display="flex" flexDirection="column" gap={2}>
			<Box mb={2}>
				<Typography variant="h4" mb="24px">
					Human Resource Tab
				</Typography>

				<Box px="16px" bgcolor="rgb(240, 245, 250)">
					<Box paddingY="16px">
						<Typography variant="body1">
							Employer information that is going to be used for signing other documents.
						</Typography>
					</Box>
				</Box>
			</Box>

			<FormGroupSection show={isEmployer}>
				<h5 style={{ fontSize: "1.165rem" /* 18px */, color: "red" }}>***This form is to be filled out by the hiring manager***</h5>
				<FormGroupSection
					title={EmployerFieldsForm.title}
					isEmployer={true}
					marginTop="24px"
					marginBottom="12px"
				>
					<EmployerFields fieldValues={allEmployerFields} />
				</FormGroupSection>
				{false && ( <DynamicFormComponent mt={2}>
					<SignatureBox
						ref={signatureRef}
						onSubmit={handleSignatureSubmit}
						existingPath={formik.values.employer_signature_path}
						boxTitle="MANAGER SIGNATURE"
						onSignComplete={() => {
							formik.setFieldValue('employer_signature', true);
						}}
						onClearComplete={() => {
							formik.setFieldValue('employer_signature', false);
						}}
					/>
				</DynamicFormComponent> )}
			</FormGroupSection>

			<SignAndSubmit
				formData={EmployerFieldsForm}
				// isSubmitDisabled={!formik.values.employer_signature || !signatureSubmitted}
				// extraValidation={[{ value: formik.values.employer_signature, field: 'Employer Signature' }]}
				onSubmit={handleFormSubmit}
				managerSubmit='yes'
			/>
			<NextAndCancel
				nextTabIndex={2}
				isNextDisabled={!submittedForms.human_resource_data_submitted}
				formData={EmployerFieldsForm}
				extraValidation={[{ value: formik.values.employer_signature, field: 'Employer Signature' }]}
			/>
		</Box>
	);
};
